import { useChannels } from "api/channels";
import { MoreElements } from "components/MoreElements/MoreElements";
import { useStyles } from "../ConditionReadOnly";

export const ChannelsBox = ({
  ids,
  "data-test-id": dataTestId,
  maxVisibleConditionDataCount,
}: {
  ids: string[];
  "data-test-id": string;
  maxVisibleConditionDataCount: number;
}) => {
  const classes = useStyles();
  const { useChannelsData } = useChannels(ids);
  const { data: channelsData } = useChannelsData(ids);

  return (
    <>
      {channelsData
        ?.slice(0, maxVisibleConditionDataCount)
        ?.map((channel: { name: string }) => (
          <div className={classes.box} data-test-id={dataTestId}>
            {channel?.name}
          </div>
        ))}
      <MoreElements
        totalItemsNumber={channelsData!?.length}
        tooltipData={{
          type: "labels",
          data: channelsData!
            ?.slice(maxVisibleConditionDataCount)
            ?.map((channel: { name: string }) => channel.name),
        }}
      />
    </>
  );
};
